window.lgSwatch = {
  size: 0,
  playmatSize: 0,
  sizeVariant: 0,
  swatches: [],
  playmates: []
}

class LgPlaymateSelections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback () {
    window.addEventListener('swatch:selection', this.updateFraction.bind(this))
    window.lgSwatch.playmatSize = 1
  }

  disconnectedCallback() {
    window.removeEventListener('swatch:selection', this.updateFraction.bind(this))
  }

  updateFraction () {
    this.querySelectorAll('.js-current-size').forEach(el => {
      el.innerHTML = window.lgSwatch.playmates.length
    })

    this.classList[window.lgSwatch.playmates.length === 0 ? 'remove' : 'add']('disabled')
  }
}

customElements.define('lg-playmate-selections', LgPlaymateSelections);


class LgPlaymateItem extends HTMLElement {
  constructor() {
    super();

    this.addButton = this.querySelector('.js-add-swatch')
    this.id = parseInt(this.dataset.id)
  }

  connectedCallback () {
    if(Boolean(this.addButton)) {
      this.addButton.addEventListener('click', this.handleClickAdd.bind(this))
    }

    window.addEventListener('swatch:selection', this.handleSelection.bind(this))
  }

  disconnectedCallback() {
    this.addButton.removeEventListener('click', this.handleClickAdd.bind(this))
  }

  handleClickAdd (e) {
    e.preventDefault()

    if (window.lgSwatch.playmates.length >= 1) return;

    const playmates = window.lgSwatch.swatches.filter(item => item !== +this.id)
    window.lgSwatch.playmates = [...playmates, +this.id]

    window.dispatchEvent(new CustomEvent('swatch:selection'))
  }

  handleSelection () {
    this.classList[window.lgSwatch.playmates.includes(+this.id) ? 'add' : 'remove']('playmate-added')
  }
}

customElements.define('lg-playmate-item', LgPlaymateItem);

class LgSwatchSelections extends HTMLElement {
  constructor() {
    super();

    this.size = parseInt(this.dataset.initialSize)
    this.sizeVariant = parseInt(this.dataset.variantId)
    this.playmateEnabled = this.dataset.playmateEnabled === 'true'

    window.lgSwatch.size = this.size
    window.lgSwatch.sizeVariant = this.sizeVariant

    this.swatchSizeInputs = this.querySelectorAll('.js-swatch-size')
  }

  connectedCallback () {
    this.swatchSizeInputs.forEach(input => input.addEventListener('input', this.handleSizeChange.bind(this)))
    window.addEventListener('swatch:selection', this.updateFraction.bind(this))
  }

  disconnectedCallback() {
    this.swatchSizeInputs.forEach(input => input.removeEventListener('input', this.handleSizeChange.bind(this)))
    window.removeEventListener('swatch:selection', this.updateFraction.bind(this))
  }

  handleSizeChange (e) {
    this.sizeVariant = parseInt(e.target.value)
    this.size = parseInt(e.target.dataset.size)

    window.lgSwatch.size = this.size
    window.lgSwatch.sizeVariant = this.sizeVariant

    document.querySelectorAll('.main-product [data-product-price]').forEach(el => el.innerHTML = e.target.dataset.price)

    window.dispatchEvent(new CustomEvent('swatch:resize'))
  }


  updateFraction () {
    this.querySelectorAll('.js-current-size').forEach(el => {
      el.innerHTML = window.lgSwatch.swatches.length
    })

    if (this.playmateEnabled) {
      this.querySelector('.lg-card').classList[window.lgSwatch.playmates.length > 0 ? 'remove' : 'add']('disabled')
    }
  }
}

customElements.define('lg-swatch-selections', LgSwatchSelections);

class LgSwatchItem extends HTMLElement {
  constructor() {
    super();

    this.addButton = this.querySelector('.js-add-swatch')
    this.id = parseInt(this.dataset.id)
  }

  connectedCallback () {
    if(Boolean(this.addButton)) {
      this.addButton.addEventListener('click', this.handleClickAdd.bind(this))
    }

    window.addEventListener('swatch:selection', this.handleSelection.bind(this))

    this.initCarousel()
  }

  disconnectedCallback() {
    this.addButton.removeEventListener('click', this.handleClickAdd.bind(this))
  }

  initCarousel () {
    if (!!this.querySelector('.js-carousel')) {
      setTimeout(() => {
        new window.themeVendor.Flickity(this.querySelector('.js-carousel'), {
          fade: true,
          wrapAround: true,
          pageDots: false
        }, 1000);
      })
    }
  }

  handleClickAdd (e) {
    e.preventDefault()

    if (window.lgSwatch.swatches.length >= window.lgSwatch.size) return;

    const swatches = window.lgSwatch.swatches.filter(item => item !== +this.id)
    window.lgSwatch.swatches = [...swatches, +this.id]

    window.dispatchEvent(new CustomEvent('swatch:selection'))
  }

  handleSelection () {
    this.classList[window.lgSwatch.swatches.includes(+this.id) ? 'add' : 'remove']('swatch-added')
  }
}

customElements.define('lg-swatch-item', LgSwatchItem);

class LgSwatchForm extends HTMLElement {
  constructor() {
    super();

    this.addButton = this.querySelector('[data-add-to-cart]')
    this.playmateEnabled = this.dataset.playmateEnabled === 'true'
    this.swatchSize = parseInt(this.dataset.swatchSize)
    this.parentId = parseInt(this.dataset.id)
    this.swatchesContainer = this.querySelector('.js-swatches-preview')
    this.playmatesContainer = this.querySelector('.js-playmate-preview')
    this.giftNoteInput = this.querySelector('.js-gift-note')
    this.playmatePlaceholder = this.dataset.playmatePlaceholder
    this.swatchPlaceholder = this.dataset.swatchPlaceholder
    this.swatchList = []
    this.playmateList = []
  }

  connectedCallback () {
    this.swatchList = JSON.parse(this.querySelector('[data-swatch-list]').textContent)
    if (this.playmateEnabled) this.playmateList = JSON.parse(this.querySelector('[data-playmate-list]').textContent)

    this.drawSelections()
    if(Boolean(this.addButton)) {
      this.addButton.addEventListener('click', this.handleClickAdd.bind(this))
    }
    window.addEventListener('swatch:resize', this.reDrawSelections.bind(this))
    window.addEventListener('swatch:selection', this.reDrawSelections.bind(this))
  }

  disconnectedCallback() {
    this.addButton.removeEventListener('click', this.handleClickAdd.bind(this))
  }

  async handleClickAdd (e) {
    e.preventDefault()

    const bundleId = crypto.randomUUID()
    const properties = Object.assign({
      _is_bundle: true,
      _bundle_id: bundleId,
      _parent_id: this.parentId
    }, (this.giftNoteInput && Shopify.country != "US") ? {
      _gift_note: this.giftNoteInput.value
    } : {})
  

    const items = [...window.lgSwatch.swatches.map(swatch => ({
      id: swatch,
      quantity: 1,
      properties
    })),
    ...window.lgSwatch.playmates.map(item => ({
      id: item,
      quantity: 1,
      properties
    }))
  ]

    this.addButton.classList.add('is-loading')

    await fetch(`${window.theme.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    if(Shopify.country == "US") {
      if (!!this.giftNoteInput) {
        await fetch(`${window.theme.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: this.giftNoteInput.value })
        })
      }
    }

    window.location.href = '/checkout'
  }

  reDrawSelections () {
    this.swatchSize = window.lgSwatch.size
    this.parentId = window.lgSwatch.sizeVariant

    this.drawSelections()
  }

  drawSelections () {
    let playmateHtml = ''
    if (window.lgSwatch.swatches.length > this.swatchSize) {
      window.lgSwatch.swatches = window.lgSwatch.swatches.slice(0, this.swatchSize)
    }

    if (this.playmateEnabled) {
      playmateHtml = `<div class="playmate-preview-item empty"><div></div><p class="small">${this.playmatePlaceholder}</p></div>`

      if (window.lgSwatch.playmates.length > 0) {
        playmateHtml = this.playmateList.filter(playmate => window.lgSwatch.playmates.includes(playmate.id))
          .map(variant => `<lg-swatch-preview
          data-id="${variant.id}"
          class="playmate-preview-item"
        >
          <div class="playmate-preview-item__media text-center">
            <img src="${variant.image_url}"/>
          </div>
          <button class="js-remove swatch-preview-item--remove" data-item-type="playmate" type="button">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cancel" viewBox="0 0 24 24">
              <path d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="playmate-item__info text-center">
            <p class="mv-0 playmate-item__title">${variant.title}</p>
            <p class="mv-0 playmate-item__subtitle">${variant.subtitle}</p>
            <p class="mv-0 playmate-item__price">${variant.price_display}</p>
          </div>
        </lg-swatch-preview>
        `).join('')
      }
    }

    const placeholderHtml = Array(this.swatchSize - window.lgSwatch.swatches.length).fill(0).map(i => `
    <div class="swatch-preview-item empty"><div></div><p class="small">${this.swatchPlaceholder}</p></div>
  `).join('')

    const swatchesHtml = window.lgSwatch.swatches.map(selection => {
      const variant = this.swatchList.find(item => item.id === selection)
      return `<lg-swatch-preview
        data-id="${variant.id}"
        class="swatch-preview-item"
      >
        <button class="js-remove swatch-preview-item--remove" data-item-type="swatch" type="button">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cancel" viewBox="0 0 24 24">
            <path d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div class="swatch-preview-media__wrapper">
          <div
            class="swatch-item-media image__fill image-wrapper"
            style="--aspect-ratio: 1;"
          >
            <img src="${variant.image_url}"/>
          </div>
        </div>

        <p class="mv-0">${variant.title}</p>
      </lg-swatch-preview>`
    }).join('')

    this.swatchesContainer.innerHTML = `${swatchesHtml}${placeholderHtml}`

    const pricing = [
      ...this.swatchList.filter(item => window.lgSwatch.swatches.includes(item.id))
      .map(item => item.price),
      ...this.playmateList.filter(item => window.lgSwatch.playmates.includes(item.id))
      .map(item => item.price)
    ].reduce((a, b) => a + b, 0)

    document.querySelectorAll('.main-product [dynamic-bundle-pricing] [data-product-price]').forEach(el => {
      el.innerHTML = window.themeVendor.themeCurrency.formatMoney(pricing, window.theme.moneyFormat).replace(/.00/g, '')
    })

    if (this.playmateEnabled) {
      this.playmatesContainer.innerHTML = playmateHtml
    }

    if (!this.playmateEnabled && this.swatchSize === window.lgSwatch.swatches.length ||
      this.playmateEnabled && this.swatchSize === window.lgSwatch.swatches.length && window.lgSwatch.playmates.length !== 0
    ) {
      this.addButton.removeAttribute('disabled')
      this.addButton.classList.remove('btn--secondary')
    } else {
      this.addButton.classList.add('btn--secondary')
      this.addButton.setAttribute('disabled', true)
    }

    this.querySelectorAll('.js-swatch-sizes').forEach(el => {
      el.innerHTML = window.lgSwatch.swatches.length
    })

    let step = 0
    if (
      window.lgSwatch.playmates.length === 0 && window.lgSwatch.swatches.length === window.lgSwatch.size ||
      window.lgSwatch.playmates.length > 0 && window.lgSwatch.swatches.length !== window.lgSwatch.size
    ) {
      step = 1
    }

    if (window.lgSwatch.playmates.length > 0 && window.lgSwatch.swatches.length === window.lgSwatch.size) {
      step = 2
    }

    this.querySelectorAll('.js-swatch-step').forEach(el => {
      el.innerHTML = step
    })
  }
}

customElements.define('lg-swatch-form', LgSwatchForm);

class LgSwatchPreview extends HTMLElement {
  constructor() {
    super();

    this.removeButton = this.querySelector('.js-remove')
    this.id = parseInt(this.dataset.id)
  }

  connectedCallback () {
    this.removeButton.addEventListener('click', this.handleRemove.bind(this))
  }

  disconnectedCallback() {
    this.removeButton.removeEventListener('click', this.handleRemove.bind(this))
  }

  handleRemove (e) {
    e.preventDefault()

    const { itemType } = e.target.dataset

    if (itemType === 'swatch') {
      window.lgSwatch.swatches = window.lgSwatch.swatches.filter(item => item !== +this.id)
    } else {
      window.lgSwatch.playmates = window.lgSwatch.playmates.filter(item => item !== +this.id)
    }

    window.dispatchEvent(new CustomEvent('swatch:selection'))
  }
}

customElements.define('lg-swatch-preview', LgSwatchPreview);

class LgProductTray extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('.js-tray-toggler')
    this.cartBar = this.querySelector('.js-cart-bar')
    this.target = document.querySelector('.product__block--buttons')
  }

  connectedCallback () {
    const observer = new IntersectionObserver(this._toggleStickyBar.bind(this), {
			rootMargin: "0px",
			threshold: 0,
		})
		observer.observe(this.target)

    this.toggleButton.addEventListener('click', this.handleToggle.bind(this))
    window.addEventListener('swatch:selection', this.reviewSelections.bind(this))
  }

  disconnectedCallback() {
    this.toggleButton.removeEventListener('click', this.handleToggle.bind(this))
  }

  handleToggle (e) {
    e.preventDefault()
    this.cartBar.classList.toggle('expanded')
  }

  _toggleStickyBar(entries) {
		const entry = entries[0]

		if (entry.isIntersecting) {
			this.cartBar.classList.remove('active')
		} else {
			// if (entry.boundingClientRect.y < 0) {
				this.cartBar.classList.add('active')
			// }
		}
	}

  reviewSelections () {
    if (window.lgSwatch.size === window.lgSwatch.swatches.length && window.lgSwatch.playmates.length === window.lgSwatch.playmatSize) {
      this.cartBar.classList.add('expanded')
    }
  }
}

customElements.define('lg-product-tray', LgProductTray);
